import { useState, useEffect } from "react";
import { API } from "../App";
import axios from "axios";
import { X, Download } from "lucide-react";
import { Button } from "./ui/button";
import { Capacitor } from "@capacitor/core";
import { Browser } from "@capacitor/browser";

// Helper to detect platform
const getPlatform = () => {
  const ua = navigator.userAgent || navigator.vendor || window.opera;
  if (/iPad|iPhone|iPod/.test(ua)) return "ios";
  if (/android/i.test(ua)) return "android";
  return "ios"; // default
};

// Current app version - UPDATE THIS when releasing new versions
const APP_VERSIONS = {
  ios: "4.5",
  android: "4.5"
};

const APP_VERSION = APP_VERSIONS[getPlatform()];

const VersionCheck = () => {
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const [storeUrl, setStoreUrl] = useState("");
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    checkVersion();
  }, []);

  const compareVersions = (v1, v2) => {
    const parts1 = v1.split(".").map(Number);
    const parts2 = v2.split(".").map(Number);
    
    for (let i = 0; i < Math.max(parts1.length, parts2.length); i++) {
      const p1 = parts1[i] || 0;
      const p2 = parts2[i] || 0;
      if (p1 < p2) return -1;
      if (p1 > p2) return 1;
    }
    return 0;
  };

  const checkVersion = async () => {
    // Check if already dismissed this session
    const dismissedVersion = sessionStorage.getItem("pourcircle_dismissed_version");
    if (dismissedVersion) {
      setDismissed(true);
      return;
    }

    try {
      const platform = getPlatform();
      const response = await axios.get(`${API}/app-version?platform=${platform}`);
      const { current_version, store_url } = response.data;

      // Compare versions
      if (compareVersions(APP_VERSION, current_version) < 0) {
        setUpdateAvailable(true);
        setStoreUrl(store_url);
      }
    } catch (e) {
      console.log("Version check failed:", e);
    }
  };

  const handleDismiss = () => {
    sessionStorage.setItem("pourcircle_dismissed_version", "true");
    setDismissed(true);
  };

  const handleUpdate = async () => {
    if (storeUrl) {
      try {
        if (Capacitor.isNativePlatform()) {
          // Use Capacitor Browser for native apps
          await Browser.open({ url: storeUrl });
        } else {
          // Fallback for web
          window.open(storeUrl, '_blank');
        }
      } catch (e) {
        console.error("Failed to open store:", e);
        // Fallback
        window.open(storeUrl, '_blank');
      }
    }
  };

  if (!updateAvailable || dismissed) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-primary p-3 shadow-lg animate-slide-down">
      <div className="flex items-center justify-between max-w-lg mx-auto">
        <div className="flex items-center gap-3 flex-1">
          <Download className="w-5 h-5 text-white flex-shrink-0" />
          <p className="text-white text-sm">
            A new version of PourCircle is available!
          </p>
        </div>
        <div className="flex items-center gap-2">
          <Button
            onClick={handleUpdate}
            size="sm"
            className="bg-white text-primary hover:bg-white/90 text-xs px-3"
          >
            Update
          </Button>
          <button
            onClick={handleDismiss}
            className="text-white/80 hover:text-white p-1"
            aria-label="Dismiss"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default VersionCheck;
